import styled from 'styled-components/macro';
import { Header2 } from '../../../shared/Headers';
import { spacing03 } from '../../../styling/spacing';
import { DocumentDetails } from '../../documents/DocumentDetails';
import { HandoverPackDocumentSection } from './handoverPackResponse';

type Props = {
  section: HandoverPackDocumentSection;
  showMenu?: boolean;
  refreshContext?: () => void;
};

export const HandoverPackSectionDetails = ({ section, showMenu, refreshContext }: Props) => {
  return (
    <SectionContainer>
      <Header2>
        {section.sectionSequence} — {section.sectionName}
      </Header2>
      {section.handoverPackDocuments.map(document => (
        <DocumentDetails
          document={{ ...document, handoverPackSection: null }}
          key={document.documentId}
          showMenu={showMenu}
          onSuccess={refreshContext}
        />
      ))}
    </SectionContainer>
  );
};

const SectionContainer = styled.div`
  margin-top: ${spacing03};
  padding-left: ${spacing03};
  padding-right: ${spacing03};
`;
